import {useMemo} from 'react';

import UserActionCollapsable from '@/components/UserOptions/components/UserActionCollapsable';
import UserActionPopup from '@/components/UserOptions/components/UserActionPopup';
import NavMenu from '@/layout/Menu';

import {USER_ACTION_TYPE} from '../constants';

export default (config) => useMemo(() => {
  switch (config?.viewType) {
    case USER_ACTION_TYPE.POPUP:
      return UserActionPopup;
    case USER_ACTION_TYPE.COLLAPSABLE:
      return UserActionCollapsable;
    case USER_ACTION_TYPE.LIST:
    default:
      return NavMenu;
  }
}, [config]);
